

















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Utils from "@/utils";
// @ts-ignore
import { LockIcon, UnlockIcon } from "vue-feather-icons";

@Component({
  components: {
    LockIcon,
    UnlockIcon,
  },
})
export default class SslBadge extends Vue {
  @Prop()
  isValid!: boolean;

  @Prop({ default: -1 })
  statusCode!: number;

  @Prop()
  url!: string;

  get isHttps(): boolean {
    return Utils.IsHttps(this.url);
  }

  get cssIconModifier(): string {
    let modifier = "";

    if (this.statusCode) {
      modifier += ` badge--${this.statusCode}`;
    }

    if (!this.isValid) {
      modifier += ` badge--empty`;
    }

    return modifier;
  }

  get tooltip(): string {
    if (!this.isHttps) {
      return "No SSL";
    } else if (this.isHttps && this.isValid) {
      return "Secure";
    } else if (this.isHttps && !this.isValid) {
      return "Not secure (certificate error)";
    }

    return "";
  }
}
